import admin from "./admin";
import organization from "./organization";
import xo from "./xo";

const translations = { ...admin, ...organization, ...xo };

export default translations;
